import React from 'react';
import './Rankings.css';

const top6 = [
  { rank: 1, initials: 'LS', name: 'Lamia Sayed', role: 'Full-Stack Dev', score: 99.2, color: '#6c63ff', pct: 99 },
  { rank: 2, initials: 'AJ', name: 'Ahmed Jawad', role: 'Senior Frontend Dev', score: 98.8, color: '#4f9eff', pct: 98 },
  { rank: 3, initials: 'SK', name: 'Sara Kadri', role: 'UX Designer', score: 97.2, color: '#22c55e', pct: 97 },
  { rank: 4, initials: 'KM', name: 'Kofi Mensah', role: 'Full-Stack', score: 96.3, color: '#a855f7', pct: 96 },
  { rank: 5, initials: 'FO', name: 'Fairouz Oweza', role: 'Full-Stack', score: 95.1, color: '#f59e0b', pct: 95 },
  { rank: 6, initials: 'SA', name: 'Sofia Amrawi', role: 'Product Design', score: 86.9, color: '#06b6d4', pct: 87 },
];

const rising = [
  { rank: 1, initials: 'SA', name: 'Sofia Amrawi', role: 'UX Design', score: 86.9, color: '#06b6d4', pct: 87 },
  { rank: 2, initials: 'CV', name: 'Celia Vaya', role: 'System Architecture', score: 81.4, color: '#ef4444', pct: 81 },
  { rank: 3, initials: 'LF', name: 'Luca Ferrakh', role: 'Data Analyst', score: 80.4, color: '#84cc16', pct: 80 },
  { rank: 4, initials: 'NO', name: 'Nela Okfado', role: 'Product Design', score: 79.1, color: '#f97316', pct: 79 },
  { rank: 5, initials: 'AD', name: 'Amara Dima', role: 'UX Design', score: 76.6, color: '#8b5cf6', pct: 77 },
  { rank: 6, initials: 'ML', name: 'Mei Lin', role: 'ML Engineering', score: 72.8, color: '#0ea5e9', pct: 73 },
];

const fullRankings = [
  { rank: 1, initials: 'LS', name: 'Lamia Sayed', score: 99.2, test: 'Backend Systems', match: '69%', status: 'Reviewed', color: '#6c63ff' },
  { rank: 2, initials: 'AJ', name: 'Ahmed Jawad', score: 98.8, test: 'Senior Frontend Dev', match: '76%', status: 'New', color: '#4f9eff' },
  { rank: 3, initials: 'SK', name: 'Sara Kadri', score: 97.2, test: 'UX Design', match: '69%', status: 'Hired', color: '#22c55e' },
  { rank: 4, initials: 'KM', name: 'Kofi Mensah', score: 96.3, test: 'Full-Stack', match: '77%', status: 'Rejected', color: '#a855f7' },
  { rank: 5, initials: 'FO', name: 'Fairouz Oweza', score: 95.1, test: 'Full-Stack', match: '89%', status: 'Reviewed', color: '#f59e0b' },
  { rank: 6, initials: 'SA', name: 'Sofia Amrawi', score: 86.9, test: 'Product Design', match: '87%', status: 'New', color: '#06b6d4' },
  { rank: 7, initials: 'CV', name: 'Celia Vaya', score: 81.4, test: 'Cloud Architecture', match: '85%', status: 'Rejected', color: '#ef4444' },
  { rank: 8, initials: 'LF', name: 'Luca Ferrakh', score: 80.4, test: 'Data Analysis', match: '82%', status: 'New', color: '#84cc16' },
  { rank: 9, initials: 'NO', name: 'Nela Okfado', score: 79.1, test: 'Product Design', match: '88%', status: 'Shortlisted', color: '#f97316' },
  { rank: 10, initials: 'AD', name: 'Amara Dima', score: 76.6, test: 'UX Design', match: '91%', status: 'Reviewed', color: '#8b5cf6' },
  { rank: 11, initials: 'ML', name: 'Mei Lin', score: 72.8, test: 'ML Engineering', match: '86%', status: 'New', color: '#0ea5e9' },
  { rank: 12, initials: 'HK', name: 'Hana Kobayashi', score: 72.2, test: 'ML Engineering', match: '80%', status: 'Rejected', color: '#d946ef' },
  { rank: 13, initials: 'JL', name: 'Jordan Lee', score: 71.7, test: 'Data Analysis', match: '82%', status: 'Shortlisted', color: '#14b8a6' },
  { rank: 14, initials: 'DR', name: 'Diego Reyes', score: 71.6, test: 'Cloud Architecture', match: '85%', status: 'Shortlisted', color: '#f43f5e' },
];

const statusColor = { Reviewed: 'blue', New: 'purple', Hired: 'green', Rejected: 'red', Shortlisted: 'yellow' };

function ScoreRow({ c, cols }) {
  return (
    <div className="rank-row">
      <span className="rank-num">{String(c.rank).padStart(2, '0')}</span>
      <div className="rank-avatar" style={{ background: c.color }}>{c.initials}</div>
      <div className="rank-info">
        <div className="rank-name">{c.name}</div>
        {c.role && <div className="rank-role">{c.role}</div>}
      </div>
      <div className="rank-bar-wrap">
        <div className="rank-bar">
          <div className="rank-bar-fill" style={{ width: `${c.pct}%`, background: c.color }} />
        </div>
      </div>
      <span className="rank-score">{c.score}</span>
    </div>
  );
}

export default function Rankings() {
  return (
    <div className="page rankings">
      <div className="page-header">
        <div>
          <h1 className="page-title">Rankings</h1>
          <p className="page-sub">Top-performing candidates ranked by assessment score</p>
        </div>
      </div>

      <div className="rank-top-grid">
        <div className="card">
          <div className="card-title" style={{ marginBottom: 4 }}>Overall Top Scorers</div>
          <div className="card-sub" style={{ marginBottom: 14 }}>Across all active tests</div>
          {top6.map((c, i) => <ScoreRow key={i} c={c} />)}
        </div>
        <div className="card">
          <div className="card-title" style={{ marginBottom: 4 }}>Rising This Week</div>
          <div className="card-sub" style={{ marginBottom: 14 }}>Highest rise in rank</div>
          {rising.map((c, i) => <ScoreRow key={i} c={c} />)}
        </div>
      </div>

      <div className="card" style={{ marginTop: 16, overflowX: 'auto' }}>
        <div className="card-title" style={{ marginBottom: 14, padding: '18px 20px 0' }}>Full Rankings</div>
        <table className="data-table" style={{ minWidth: 800 }}>
          <thead>
            <tr>
              <th>RANK</th>
              <th>CANDIDATE</th>
              <th>SCORE</th>
              <th>TEST</th>
              <th>MATCH</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {fullRankings.map((c, i) => (
              <tr key={i}>
                <td style={{ color: 'var(--text-muted)' }}>#{c.rank}</td>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 26, height: 26, borderRadius: '50%', background: c.color, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 9, fontWeight: 700, flexShrink: 0 }}>{c.initials}</div>
                    <span style={{ color: 'var(--text-primary)', fontWeight: 500 }}>{c.name}</span>
                  </div>
                </td>
                <td style={{ fontWeight: 600, color: 'var(--text-primary)' }}>{c.score}</td>
                <td>{c.test}</td>
                <td>{c.match}</td>
                <td><span className={`status-badge ${statusColor[c.status]}`}>{c.status}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}